import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from '@/lib/customBaseQuery';

const modFaqBaseUrl = '/api/mod_faq';
export const modFaqApi = createApi({
  reducerPath: 'modFaqApi',
  baseQuery: customBaseQuery,
  tagTypes: ['ModFAQ'],
  endpoints: (builder) => ({
    getModFAQ: builder.query<MODFAQData[], void>({
      query: () => ({
        url: modFaqBaseUrl,
      }),
      providesTags: ['ModFAQ'],
    }),
    saveModFAQ: builder.mutation<MOD, ModPostPayload>({
      query: (payload) => ({
        url: modFaqBaseUrl,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['ModFAQ'],
    }),
  }),
});

export const { useGetModFAQQuery, useSaveModFAQMutation } = modFaqApi;
